module.exports = __webpack_public_path__ + "static/media/phone-icon.f6ac80d0.svg";